(function () {
  'use strict';

  window.EGCart = {

    _isOpen: false,
    _isFetching: false,

    init: function () {
      this._drawer   = document.getElementById('eg-cart-drawer');
      this._overlay  = document.getElementById('eg-cart-overlay');
      this._closeBtn = document.getElementById('eg-cart-close');
      this._bodyEl   = document.getElementById('eg-cart-body');
      this._footerEl = document.getElementById('eg-cart-footer');

      if (!this._drawer) return;

      this._overlay.addEventListener('click', this.close.bind(this));
      this._closeBtn.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && EGCart._isOpen) EGCart.close();
      });

      // Cart icon — capture phase fires before Horizon's own listeners
      document.addEventListener('click', function (e) {
        var el = e.target.closest(
          'a[href="/cart"], a[href$="/cart"], ' +
          '[aria-controls="cart-drawer"], ' +
          '[data-action="open-cart"], ' +
          '[data-cart-toggle]'
        );
        if (!el) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        EGCart.open();
      }, true);

      // ATC forms — capture phase intercepts before Horizon's product-form.js
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.id === 'eg-cart-discount-form') return;
        var action = (form.getAttribute('action') || '').replace(/\?.*$/, '');
        if (!action.match(/\/cart\/add$/)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        EGCart._ajaxAdd(form);
      }, true);

      // If Horizon somehow opens its hidden <cart-drawer>, hijack it
      var hd = document.querySelector('cart-drawer');
      if (hd) {
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            if (muts[i].attributeName === 'open' && hd.hasAttribute('open')) {
              hd.removeAttribute('open');
              if (!EGCart._isOpen) EGCart.open();
              break;
            }
          }
        }).observe(hd, { attributes: true, attributeFilter: ['open'] });
      }
    },

    _ajaxAdd: function (form) {
      var btn = form.querySelector('[type="submit"]');
      var origLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) {
              throw new Error(d.description || 'Error adding item');
            });
          }
          return r.json();
        })
        .then(function () {
          if (btn) {
            btn.textContent = 'Added!';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = origLabel;
            }, 1600);
          }
          EGCart.open();
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.textContent = origLabel; }
          console.error('[EGCart] Add to cart failed:', err.message);
        });
    },

    open: function () {
      this._isOpen = true;
      this._drawer.classList.add('egcd--open');
      this._overlay.classList.add('egcd-overlay--on');
      document.body.classList.add('egcd-lock');
      this._drawer.setAttribute('aria-hidden', 'false');
      this._fetchAndRender();
    },

    close: function () {
      this._isOpen = false;
      this._drawer.classList.remove('egcd--open');
      this._overlay.classList.remove('egcd-overlay--on');
      document.body.classList.remove('egcd-lock');
      this._drawer.setAttribute('aria-hidden', 'true');
    },

    _fetchAndRender: function () {
      if (this._isFetching) return;
      this._isFetching = true;
      this._bodyEl.innerHTML = '<div class="egcd-loading" role="status">Loading cart…</div>';
      this._footerEl.innerHTML = '';

      var self = this;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._isFetching = false;
          self._renderBody(cart);
          self._renderFooter(cart);
          self._syncBadge(cart.item_count);
        })
        .catch(function () {
          self._isFetching = false;
          self._bodyEl.innerHTML =
            '<p class="egcd-error">Could not load cart. ' +
            '<a href="/cart">View cart page →</a></p>';
        });
    },

    _money: function (cents) {
      return '$' + (cents / 100).toFixed(2);
    },

    _renderBody: function (cart) {
      var countEl = document.getElementById('egcd-count');
      if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

      if (!cart.item_count) {
        this._bodyEl.innerHTML =
          '<div class="egcd-empty">' +
            '<svg aria-hidden="true" width="48" height="48" fill="none" stroke="currentColor" ' +
              'stroke-width="1.3" viewBox="0 0 24 24">' +
              '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
              '<line x1="3" y1="6" x2="21" y2="6"/>' +
              '<path d="M16 10a4 4 0 01-8 0"/>' +
            '</svg>' +
            '<p>Your cart is empty.</p>' +
            '<button type="button" class="egcd-empty-btn" onclick="EGCart.close()">' +
              'Continue Shopping' +
            '</button>' +
          '</div>';
        return;
      }

      var rows = cart.items.map(function (item, i) {
        var line = i + 1;
        var vt = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<span class="egcd-item__variant">' + item.variant_title + '</span>'
          : '';

        var thumb = item.image
          ? '<a class="egcd-item__thumb" href="' + item.url + '" onclick="EGCart.close()" tabindex="-1">' +
              '<img src="' + item.image + '" alt="" loading="lazy" width="80" height="80">' +
            '</a>'
          : '<div class="egcd-item__thumb egcd-item__thumb--empty"></div>';

        return (
          '<li class="egcd-item">' +
            thumb +
            '<div class="egcd-item__info">' +
              '<a class="egcd-item__name" href="' + item.url + '" onclick="EGCart.close()">' +
                item.product_title +
              '</a>' +
              vt +
              '<span class="egcd-item__price">' + EGCart._money(item.final_line_price) + '</span>' +
            '</div>' +
            '<div class="egcd-item__actions">' +
              '<div class="egcd-qty" role="group" aria-label="Quantity">' +
                '<button type="button" class="egcd-qty__btn" aria-label="Decrease quantity" ' +
                  'onclick="EGCart.changeLine(' + line + ',' + (item.quantity - 1) + ')">&#8722;</button>' +
                '<span class="egcd-qty__val" aria-live="polite">' + item.quantity + '</span>' +
                '<button type="button" class="egcd-qty__btn" aria-label="Increase quantity" ' +
                  'onclick="EGCart.changeLine(' + line + ',' + (item.quantity + 1) + ')">&#43;</button>' +
              '</div>' +
              '<button type="button" class="egcd-item__remove" ' +
                'onclick="EGCart.changeLine(' + line + ',0)" ' +
                'aria-label="Remove ' + item.product_title + '">Remove</button>' +
            '</div>' +
          '</li>'
        );
      });

      this._bodyEl.innerHTML = '<ul class="egcd-list" role="list">' + rows.join('') + '</ul>';
    },

    _renderFooter: function (cart) {
      if (!cart.item_count) {
        this._footerEl.innerHTML = '';
        return;
      }

      this._footerEl.innerHTML =
        '<div class="egcd-subtotal">' +
          '<span>Subtotal</span>' +
          '<strong>' + this._money(cart.total_price) + '</strong>' +
        '</div>' +
        '<form id="eg-cart-discount-form" class="egcd-discount" onsubmit="EGCart.applyDiscount(event)">' +
          '<input id="egcd-disc-input" type="text" class="egcd-discount__input" ' +
            'placeholder="Discount code" aria-label="Discount code" autocomplete="off">' +
          '<button type="submit" class="egcd-discount__btn">Apply</button>' +
        '</form>' +
        '<p class="egcd-billing">Customer will be billed by Edible Growth LLC.</p>' +
        '<a id="egcd-checkout-link" href="/checkout" class="egcd-checkout-btn">' +
          'Proceed to Checkout' +
        '</a>' +
        '<button type="button" class="egcd-continue" onclick="EGCart.close()">' +
          '← Continue Shopping' +
        '</button>';
    },

    changeLine: function (line, qty) {
      var self = this;
      this._bodyEl.querySelectorAll('.egcd-qty__btn, .egcd-item__remove').forEach(function (b) {
        b.disabled = true;
      });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._renderBody(cart);
          self._renderFooter(cart);
          self._syncBadge(cart.item_count);
        })
        .catch(function () {
          self._isFetching = false;
          self._fetchAndRender();
        });
    },

    applyDiscount: function (e) {
      e.preventDefault();
      var inp = document.getElementById('egcd-disc-input');
      var code = inp ? inp.value.trim() : '';
      if (!code) return;

      var link = document.getElementById('egcd-checkout-link');
      if (link) link.href = '/checkout?discount=' + encodeURIComponent(code);

      if (inp) {
        inp.value = '';
        inp.placeholder = '"' + code + '" applied ✓';
        inp.classList.add('egcd-discount__input--applied');
        setTimeout(function () {
          inp.placeholder = 'Discount code';
          inp.classList.remove('egcd-discount__input--applied');
        }, 3000);
      }
    },

    _syncBadge: function (n) {
      document.querySelectorAll(
        '.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .badge--count'
      ).forEach(function (el) { el.textContent = n > 0 ? n : ''; });
    }

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { EGCart.init(); });
  } else {
    EGCart.init();
  }

}());
